import ApiService from './api.service';
import { stringify } from 'query-string';

export const Login = payload => {
  return ApiService.post('auth/login', {
    user: payload,
  });
};

export const GetUser = () => {
  //ApiService.setHeader();
  return ApiService.get('user');
};

export const RegisterUser = payload => {
  return ApiService.post('user', {
    user: payload,
  });
};

export const RegisterUserFromMobile = payload => {
  return ApiService.post('user/mobile', {
    user: payload,
  });
};

export const RegisterCEO = payload => {
  return ApiService.post('user/ceo', {
    user: payload,
  });
};

export const AuthReq = payload => {
  return ApiService.post(`auth/certification`, payload, {
    isErrMsg: false,
    //isErrToast: true,
  });
};

export const AuthConfirm = payload => {
  return ApiService.post(`auth/certification/confirm`, payload, {
    isErrMsg: false,
    isErrToast: true,
  });
};

export const socialCheck = payload => {
  return ApiService.post(`user/social/check?${stringify(payload)}`);
};

export const socialRegister = payload => {
  return ApiService.post(`user/social?${stringify(payload)}`);
};
